import type { RouteRecordRaw } from 'vue-router';

import { ROUTES } from '@/constants/routes';
import i18n from '@/i18n';

import type { BreadcrumbProps } from '@/dsComponents/breadcrumbs/types';

const routes: RouteRecordRaw[] = [
	{
		path: 'clients',
		name: ROUTES.APP.CLIENTS,
		component: () =>
			import(/* webpackChunkName: "clients" */ './views/Clients.vue'),
		meta: {
			viewFilters: [
				{ name: 'client', defaultValue: '' },
				{ name: 'businessSector', defaultValue: '' },
				{ name: 'zip', defaultValue: '' },
			],
			breadcrumbs: <BreadcrumbProps>{
				items: [
					{
						label: i18n.global.t('breadcrumbs.clients.root'),
						icon: 'company',
						link: { name: ROUTES.APP.CLIENTS },
					},
				],
			},
		},
	},
	{
		path: 'client/:companyId',
		name: ROUTES.APP.CLIENT._ROOT,
		component: () =>
			import(/* webpackChunkName: "client" */ './views/Layout.vue'),
		redirect: (to) => ({
			name: ROUTES.APP.CLIENT.INFORMATIONS,
			params: to.params,
		}),
		children: [
			{
				path: 'informations',
				name: ROUTES.APP.CLIENT.INFORMATIONS,
				component: () =>
					import(/* webpackChunkName: "client" */ './views/ClientIdentity.vue'),
			},
			{
				path: 'contacts',
				name: ROUTES.APP.CLIENT.CONTACTS,
				component: () =>
					import(/* webpackChunkName: "client" */ './views/ClientContact.vue'),
			},
			{
				path: 'addresses',
				name: ROUTES.APP.CLIENT.ADDRESSES,
				component: () =>
					import(/* webpackChunkName: "client" */ './views/ClientAddress.vue'),
			},
			{
				path: 'company-needs',
				name: ROUTES.APP.CLIENT.COMPANY_NEEDS,
				component: () =>
					import(
						/* webpackChunkName: "client" */ './views/ClientCompanyNeeds.vue'
					),
			},
			{
				path: 'order',
				name: ROUTES.APP.CLIENT.ORDER,
				component: () =>
					import(/* webpackChunkName: "client" */ './views/Order.vue'),
			},
			{
				path: 'avis',
				name: ROUTES.APP.CLIENT.REVIEWS,
				component: () =>
					import(/* webpackChunkName: "client" */ './views/Reviews.vue'),
			},
		],
	},
];

export default routes;
